module.exports = __webpack_public_path__ + "img/wallet-cod-withdrawal.d0052a4f.svg";